// -disable-next-line import/prefer-default-export
export const DISCHARGE_STATUS = {
  TOTAL_WITH_PICTURE: 0, // Baixa total com foto
  TOTAL_WITHOUT_PICTURE: 1, // Baixa total sem foto
  PARTIAL_WITH_PICTURE: 2, // Baixa parcial com foto
  PARTIAL_WITHOUT_PICTURE: 3, // Baixa parcial sem foto
  DENIED_WITH_PICTURE: 4, // Recusada com foto
  DENIED_WITHOUT_PICTURE: 5, // Recusada sem foto
};
